import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    ICommissionRegister, ICommissionSettlement, IRecordSettlementRequest,
} from '../interfaces/agentCommission.interface';

const headers = () => AuthService.getAuthHeader();

export const AgentCommissionService = {
    register: async (institutionId: string, agentPartyId?: string): Promise<ICommissionRegister> =>
        (await axios.get(ENDPOINTS.AGENT_COMMISSION.REGISTER(institutionId), { headers: headers(), params: { agentPartyId } })).data,

    settlements: async (
        institutionId: string, agentPartyId?: string, buyerOrderId?: string, includeVoided = false,
    ): Promise<ICommissionSettlement[]> =>
        (await axios.get(ENDPOINTS.AGENT_COMMISSION.SETTLEMENTS(institutionId), {
            headers: headers(), params: { agentPartyId, buyerOrderId, includeVoided },
        })).data,

    record: async (institutionId: string, request: IRecordSettlementRequest): Promise<ICommissionSettlement> =>
        (await axios.post(ENDPOINTS.AGENT_COMMISSION.SETTLEMENTS(institutionId), request, { headers: headers() })).data,

    voidSettlement: async (institutionId: string, id: string, reason: string): Promise<ICommissionSettlement> =>
        (await axios.post(ENDPOINTS.AGENT_COMMISSION.VOID(institutionId, id), { reason }, { headers: headers() })).data,

    downloadStatement: async (institutionId: string, agentPartyId: string): Promise<{ data: Blob; headers: Record<string, string> }> =>
        axios.get(ENDPOINTS.AGENT_COMMISSION.STATEMENT_XLSX(institutionId), {
            headers: headers(), params: { agentPartyId }, responseType: 'blob',
        }),
};
